import { SWMS_SHIFT_PRE_START_CHECKLIST_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

const USE_PRE_START_MOCK = false;
const MOCK_DELAY_MS = 450;

const buildMockChecklist = ({ jobId, swmsId, shiftId }) => ({
  pre_start_checklist: {
    pre_start_id: "J10474T21SV1-PSC-7874",
    org_id: 1,
    job_id: Number(jobId) || null,
    shift_id: `${shiftId || ""}`,
    swms_id: swmsId || "",
    swms_number: "J10474T21SV1",
    snapshot_questions: [
      {
        id: 101,
        question_text: "Is the SWMS current and does it match today's task?",
        guidance_text: "Review the work pack before mobilising.",
        answer_scope: "supervisor",
        required: true,
        active: true,
        display_order: 1,
        response_config: {
          schemaVersion: 1,
          type: "radio",
          options: [
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" }
          ],
          flagOnValue: "no"
        }
      },
      {
        id: 102,
        question_text: "Record the current wind speed.",
        guidance_text: "Check against rope-access cut-off before starting.",
        answer_scope: "supervisor",
        required: true,
        active: true,
        display_order: 2,
        response_config: {
          schemaVersion: 1,
          type: "number",
          unit: "km/h"
        }
      },
      {
        id: 103,
        question_text: "Are you fit for work today?",
        guidance_text: "",
        answer_scope: "worker",
        required: true,
        active: true,
        display_order: 3,
        response_config: {
          schemaVersion: 1,
          type: "radio",
          options: [
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" }
          ],
          flagOnValue: "no"
        }
      },
      {
        id: 104,
        question_text: "Is this check applicable to today's shift?",
        guidance_text: "Use N/A where the control is not relevant for the planned task.",
        answer_scope: "supervisor",
        required: true,
        active: true,
        display_order: 4,
        response_config: {
          schemaVersion: 1,
          type: "radio",
          options: [
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" },
            { value: "not_applicable", label: "N/A" }
          ],
          flagOnValue: null
        }
      },
      {
        id: 105,
        question_text: "Has each person checked their PPE before starting?",
        guidance_text: "Confirm harness, helmet and tools are inspected before access.",
        answer_scope: "worker",
        required: true,
        active: true,
        display_order: 5,
        response_config: {
          schemaVersion: 1,
          type: "radio",
          options: [
            { value: "pass", label: "Pass" },
            { value: "fail", label: "Fail" }
          ],
          flagOnValue: "fail"
        }
      },
      {
        id: 106,
        question_text: "Describe any additional controls introduced at the pre-start.",
        guidance_text: "Capture the shift-specific controls communicated to the team.",
        answer_scope: "supervisor",
        required: true,
        active: true,
        display_order: 6,
        response_config: {
          schemaVersion: 1,
          type: "text",
          multiline: true
        }
      },
      {
        id: 107,
        question_text: "Supervisor acknowledgement signature.",
        guidance_text: "",
        answer_scope: "supervisor",
        required: true,
        active: true,
        display_order: 7,
        response_config: {
          schemaVersion: 1,
          type: "signature"
        }
      },
      {
        id: 108,
        question_text: "Upload a photo of the workface or exclusion setup.",
        guidance_text: "Provide a current shift photo before work commences.",
        answer_scope: "supervisor",
        required: true,
        active: true,
        display_order: 8,
        response_config: {
          schemaVersion: 1,
          type: "photo"
        }
      }
    ],
    shift_answers: {
      supervisor_submission: {
        staff_id: "7919770284",
        staff_name: "Amir Jelvani",
        staff_role: "Supervisor",
        staff_phone: "0412 345 678",
        signed_person_type: "SUPERVISOR",
        signed_at: "2026-07-21T01:15:30.000Z",
        answers: [
          {
            question_id: 101,
            value: "yes",
            comment: "SWMS reviewed with crew.",
            flagged_response: null
          },
          {
            question_id: 102,
            value: 18,
            comment: "",
            flagged_response: null
          },
          {
            question_id: 103,
            value: "yes",
            comment: "Supervisor confirmed fit for work before toolbox.",
            flagged_response: null
          },
          {
            question_id: 104,
            value: "not_applicable",
            comment: "No suspended loads planned on this shift.",
            flagged_response: null
          },
          {
            question_id: 105,
            value: "pass",
            comment: "Supervisor PPE inspected and compliant.",
            flagged_response: null
          },
          {
            question_id: 106,
            value: "Installed a revised barricade zone around the loading area due to adjacent pedestrian traffic.",
            comment: "",
            flagged_response: null
          },
          {
            question_id: 107,
            value: {
              sign_url: "https://dummyimage.com/240x80/ededed/333333&text=Supervisor+Ack+Signature"
            },
            comment: "",
            flagged_response: null
          },
          {
            question_id: 108,
            value: {
              url: "https://dummyimage.com/640x360/dbeafe/1e3a8a&text=Site+Setup+Photo"
            },
            comment: "",
            flagged_response: null
          }
        ],
        signature: {
          sign_url: "https://dummyimage.com/240x80/ededed/333333&text=Supervisor+Signature"
        }
      },
      worker_submissions: [
        {
          staff_id: "4475988608",
          staff_name: "Kamlesh Purma",
          signed_person_type: "STAFF",
          signed_at: "2026-07-21T01:16:07.670Z",
          is_proxy: false,
          proxy_by_id: null,
          proxy_by_name: null,
          submitted_by_id: "4475988608",
          added_on_the_fly: false,
          added_person_name: null,
          added_person_phone: null,
          added_person_role: null,
          answers: [
            {
              question_id: 103,
              value: "yes",
              comment: "",
              flagged_response: null
            },
            {
              question_id: 105,
              value: "pass",
              comment: "Harness and lanyard checked before access.",
              flagged_response: null
            }
          ],
          signature: {
            sign_url: "https://dummyimage.com/240x80/ededed/333333&text=Worker+Signature"
          }
        },
        {
          staff_id: null,
          staff_name: "",
          signed_person_type: "STAFF",
          signed_at: "2026-07-21T01:17:07.670Z",
          is_proxy: true,
          proxy_by_id: "7919770284",
          proxy_by_name: "Amir Jelvani",
          submitted_by_id: "7919770284",
          added_on_the_fly: true,
          added_person_name: "Roger Federer",
          added_person_phone: "0412 345 678",
          added_person_role: "Rope Access Technician",
          answers: [
            {
              question_id: 103,
              value: "no",
              comment: "Mild migraine, moved to spotting duties.",
              flagged_response: "Supervisor reassigned high-risk tasks."
            },
            {
              question_id: 105,
              value: "fail",
              comment: "Glove replacement required before commencing.",
              flagged_response: "Replacement gloves issued and PPE rechecked by supervisor."
            }
          ],
          signature: {
            sign_url: "https://dummyimage.com/240x80/ededed/333333&text=Proxy+Signature"
          }
        }
      ]
    },
    meta: {
      "sequence": {
        "active": [
          {
            "item_type_id": null,
            "item_type": "default",
            "item_key": "high_risk_activities",
            "active": 1,
            "id": 422,
            "sequence_order": 3,
            "display_name": "High Risk Activities"
          },
          {
            "item_type_id": 1,
            "item_type": "method_item_type",
            "item_key": "method_item_type_1",
            "active": 1,
            "id": 426,
            "sequence_order": 4,
            "display_name": "Occupational Health & Safety Legislation"
          }
        ],
        "fixed": [
          {
            "item_type_id": null,
            "item_type": "fixed",
            "item_key": "document_project_details",
            "active": 1,
            "id": 420,
            "sequence_order": 1,
            "display_name": "Document & Project Details"
          },
          {
            "item_type_id": null,
            "item_type": "fixed",
            "item_key": "document_authorization",
            "active": 1,
            "id": 421,
            "sequence_order": 2,
            "display_name": "Document Authorization"
          }
        ],
        "inactive": []
      },
      "risk_matrix": {
        "toggle": 1
      },
      "template_version": 3,
      "likelihoods": [
        {
          "name": "Almost certain",
          "description": null,
          "active": 1,
          "id": 1,
          "value": 2
        },
        {
          "name": "Likely",
          "description": null,
          "active": 1,
          "id": 2,
          "value": 5
        }
      ],
      "risk_ratings": {
        "toggle": 1,
        "risk_rating_items": [
          {
            "rating_order": 1,
            "risk_rating_label": "",
            "risk_ratings": "Very Low",
            "active": 1,
            "id": 1,
            "risk_rating_description": "Very Low Risk Ratings",
            "risk_rating_high_value": 5,
            "risk_rating_low_value": 1,
            "risk_colours": "#62fe6c",
            "status": "Active"
          },
          {
            "rating_order": 2,
            "risk_rating_label": "",
            "risk_ratings": "Low Risk",
            "active": 1,
            "id": 2,
            "risk_rating_description": "Low Rating",
            "risk_rating_high_value": 10,
            "risk_rating_low_value": 6,
            "risk_colours": "#e2c012",
            "status": "Active"
          }
        ]
      },
      "consequences": [
        {
          "name": "Very Major Injury",
          "description": "Test Description",
          "active": 1,
          "id": 1,
          "value": 1
        },
        {
          "name": "Testing Consequence Update 5308",
          "description": "Testing Update",
          "active": 1,
          "id": 4,
          "value": 1
        },

      ],
      "hierarchy_of_controls": [
        {
          "name": "Eliminate",
          "description": "Remove the hazard completely.",
          "id": 11
        },
        {
          "name": "Substitute",
          "description": "Replace substance / process with a safer alternative.",
          "id": 22
        },

      ],
      heading_contents: [
        {
          heading_key: "prestart_checklist_heading",
          heading_content: "<p>Complete this checklist before work commences. Confirm controls and communicate changes to the crew.</p>"
        },
        {
          heading_key: "prestart_staff_signoff",
          heading_content: "<p>By signing, each participant confirms they understand today&apos;s hazards and controls.</p>"
        }
      ],
    },
    sections: {
      document_project_details: {
        "id": 420,
        "sequence_order": 1,
        "display_name": "Document & Project Details",
        "type": "fixed",
        "data": {
          "attachments": {
            "value": [],
            "toggle": 0
          },
          "swms_no": "7",
          "methods": [
            {
              "name": "Install Circuit Breaker",
              "id": 5
            },
            {
              "name": "New Method Test 11",
              "id": 11
            },
            {
              "name": "Pre Starts",
              "id": 1
            },
            {
              "name": "Rescue Plan",
              "id": 3
            }
          ],
          "swms_version": "v2",
          "org_details": {
            "organisation_type": 1,
            "website": null,
            "delivery_address": "Level 1 92 Railway Street South, Altona, Victoria, 3018",
            "accounting_id": null,
            "address": "Level 1 92 Railway Street South, Altona, Victoria, 3018",
            "delivery_instructions": "<div>\n    Please quote the Order no. shown on all relevant invoices,delivery dockets and correspondence.<br/>\n    Send invoices associated with this Order to<br/>               \n    abbb@reception.com.au<br/>               \n    Reception             \n</div>",
            "bucket_name": "org-logo",
            "abn_acn": "323 422 223",
            "supplementary_conditions": "As per the terms and conditions along with this order and Occupational Health and Safety conditions were attached.",
            "multi_org_logo": "famaso_1687254139/org-logo/logo-1731124691764.png",
            "po_tnc": null,
            "email_address": "mikhil.kotak@famaso.com.au",
            "name": "FAMASO2",
            "files_path": "https://d37h9fwan2kyns.cloudfront.net/famaso_1687254139",
            "logo": "https://d37h9fwan2kyns.cloudfront.net/famaso_1687254139/org-logo/logo-1731124691764.png",
            "phone_number": "9123453400",
            "id": 1,
            "org_code": "FMS2",
            "slug": "famaso_1687254139",
            "parent_org_id": 0,
            "primary_person": "Mikhil Kotak"
          },
          "areas": {
            "toggle": 1,
            "values": [
              "Test AreaName1",
              "Test AreaName1 Test1",
              "Test AreaName1 test2"
            ]
          },
          "swms_number": "J1034-SWMS-7-V2",
          "site_name": "Craft Victoria",
          "po_number": "",
          "client_details": {
            "client_contact_person_name": "Ameya Linge",
            "client_contact_role": "Manager",
            "client_contact_email": "ameyalinge@yopmail.com",
            "client_abn": "567788899",
            "client_phone": "788990000",
            "client_person_id": 105,
            "client_email": "yash@yopmail.com",
            "client_contact_name": "Ameya Linge",
            "client_contact_phone": "08446544597",
            "client_website": "",
            "client_address": "Victoria Market Pharmacy 523 Elizabeth St, Melbourne VIC 3000, Australia",
            "client_name": "AL-Test"
          },
          "scope_of_work": {
            "value": "",
            "toggle": 1
          },
          "issue_date": "2026-07-15",
          "site_address": "Craft Victoria Craft, Watson Pl, Melbourne VIC 3000, Australia",
          "state_id": 6,
          "job_number": "J1034",
          "categories": [
            {
              "name": "Test Category",
              "id": 6
            },
            {
              "name": "Electrical Work",
              "id": 4
            },
            {
              "name": "Rope Access",
              "id": 5
            }
          ],
          "swms_name": "Test SWMS",
          "company_details": {
            "company_phone": "9123453400",
            "company_email": "mikhil.kotak@famaso.com.au",
            "company_abn": "323 422 223",
            "company_address": "Level 1 92 Railway Street South, Altona, Victoria, 3018",
            "company_name": "FAMASO2",
            "company_website": ""
          },
          "qli_areas": {
            "value": [
              {
                "name": "Rope access glass cleaning",
                "display_name": "T1 - Rope access glass cleaning",
                "id": 2779
              }
            ],
            "toggle": 1
          }
        }
      },
      pdf: {
        pdf_file: null,
        pdf_link: null,
        pdf_status: null
      }
    }
  }
});

export const getJobShiftPreStartChecklist = ({ jobId, swmsId, shiftId }, abortController = {}) => () => {
  if (!jobId || !swmsId || !shiftId) {
    return Promise.reject(Strings.generic_error);
  }

  if (USE_PRE_START_MOCK) {
    return new Promise((resolve, reject) => {
      const signal = abortController && abortController.signal;
      let timeoutId = null;

      const cleanup = () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (signal && signal.removeEventListener) {
          signal.removeEventListener("abort", onAbort);
        }
      };

      const onAbort = () => {
        cleanup();
        reject(Strings.network_error);
      };

      if (signal && signal.aborted) {
        reject(Strings.network_error);
        return;
      }

      if (signal && signal.addEventListener) {
        signal.addEventListener("abort", onAbort);
      }

      timeoutId = setTimeout(() => {
        cleanup();
        resolve(buildMockChecklist({ jobId, swmsId, shiftId }));
      }, MOCK_DELAY_MS);
    });
  }

  return scopeApiInstance.get(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/pre-start-checklist`,
    { ...abortController }
  ).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : Strings.network_error
      );
    }

    return Promise.reject(null);
  });
};

export const generateJobShiftPreStartChecklistPdf = ({ jobId, swmsId, shiftId }) => () => {
  if (!jobId || !swmsId || !shiftId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.post(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/pre-start-checklist/pdf`,
    {}
  ).then((res) => {
    if (res && res.data) {
      return Promise.resolve(res.data.data || res.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : Strings.network_error
      );
    }

    return Promise.reject(null);
  });
};

export const saveJobShiftPreStartChecklistResponses = ({ jobId, swmsId, shiftId, payload }) => () => {
  if (!jobId || !swmsId || !shiftId || !payload) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.put(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/pre-start-checklist`,
    payload
  ).then((res) => {
    if (res && res.data) {
      return Promise.resolve(res.data.data || res.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : Strings.network_error
      );
    }

    return Promise.reject(null);
  });
};
